import { fr } from "date-fns/locale";
export default { locale: fr };
